var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,40.6c1,0,1.8-0.3,2.5-1c0.7-0.7,1-1.5,1-2.5c0-1-0.3-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1c-1,0-1.8,0.3-2.5,1 c-0.7,0.7-1,1.5-1,2.5c0,1,0.3,1.8,1,2.5C45.4,40.3,46.2,40.6,47.2,40.6L47.2,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.2,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.3,46c1,1,2.2,1.5,3.7,1.5s2.7-0.5,3.7-1.5c1-1,1.5-2.2,1.5-3.7s-0.5-2.7-1.5-3.7c-1-1-2.2-1.5-3.7-1.5 s-2.7,0.5-3.7,1.5c-1,1-1.5,2.2-1.5,3.7S50.3,45,51.3,46L51.3,46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.3,46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,40.6c1,0,1.8-0.3,2.5-1c0.7-0.7,1-1.5,1-2.5c0-1-0.3-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1c-1,0-1.8,0.3-2.5,1 c-0.7,0.7-1,1.5-1,2.5c0,1,0.3,1.8,1,2.5C61,40.3,61.8,40.6,62.8,40.6L62.8,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,40.6c-0.1,0-0.3,0.1-0.6,0.3c-0.3,0.2-0.8,0.4-1.3,0.6c-0.5,0.2-1.1,0.3-1.6,0.3c-0.6,0-1.2-0.1-1.8-0.3 c0,0.3,0.1,0.6,0.1,0.9c0,1.3-0.4,2.4-1.1,3.5c1.5,0,2.7,0.6,3.6,1.7h1.8c0.7,0,1.4-0.2,1.9-0.5c0.5-0.4,0.8-0.9,0.8-1.6 C68,42.2,67.4,40.6,66.3,40.6L66.3,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,40.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.3,51.5c-0.1-0.5-0.2-1-0.4-1.5c-0.1-0.5-0.3-0.9-0.6-1.3c-0.2-0.4-0.5-0.8-0.8-1.1 c-0.3-0.3-0.7-0.5-1.2-0.7c-0.5-0.2-1-0.3-1.5-0.3c-0.1,0-0.3,0.1-0.6,0.3c-0.3,0.2-0.6,0.4-1,0.7c-0.4,0.2-0.8,0.5-1.4,0.6 c-0.6,0.2-1.2,0.3-1.8,0.3c-0.6,0-1.2-0.1-1.8-0.3c-0.6-0.2-1.1-0.4-1.4-0.6c-0.4-0.2-0.7-0.5-1-0.7c-0.3-0.2-0.5-0.3-0.6-0.3 c-0.6,0-1.1,0.1-1.5,0.3c-0.5,0.2-0.8,0.4-1.2,0.7c-0.3,0.3-0.6,0.7-0.8,1.1c-0.2,0.4-0.4,0.9-0.6,1.3c-0.1,0.5-0.3,0.9-0.4,1.5 c-0.1,0.5-0.2,1-0.2,1.5c0,0.5,0,0.9,0,1.4c0,1.1,0.3,1.9,1,2.6c0.7,0.6,1.5,0.9,2.6,0.9h11.8c1.1,0,2-0.3,2.6-0.9 c0.7-0.6,1-1.5,1-2.6c0-0.5,0-0.9,0-1.4C64.5,52.6,64.4,52.1,64.3,51.5L64.3,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.3,51.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,45.8c-0.7-1.1-1.1-2.2-1.1-3.5c0-0.3,0-0.6,0.1-0.9c-0.6,0.2-1.2,0.3-1.8,0.3c-0.5,0-1.1-0.1-1.6-0.3 c-0.5-0.2-1-0.4-1.3-0.6c-0.3-0.2-0.5-0.3-0.6-0.3c-1.1,0-1.7,1.6-1.7,4.8c0,0.7,0.3,1.2,0.8,1.6c0.5,0.4,1.1,0.5,1.9,0.5h1.8 C47.4,46.4,48.6,45.8,50,45.8L50,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,45.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDefault);
export default __webpack_public_path__ + "static/media/users-default.46272c8d965c1a3fbb5bf24dc1ee7c04.svg";
export { ForwardRef as ReactComponent };